import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import PATHS from '~/app/utils/paths';
import loadable from '@loadable/component';

// Use loadable to load the FX Fleet components (login/register now handled in ScaffoldContainer)
const FXFleetCompanyInfoPage = loadable(() => import(/* webpackChunkName: "FXFleetCompanyInfoPage" */ '~/app/pages/FXFleetPage/CompanyInfo/FXFleetCompanyInfoPage'));
const FXFleetPreorderPage = loadable(() => import(/* webpackChunkName: "FXFleetPreorderPage" */ '~/app/pages/FXFleetPage/FXFleetPreorder/FXFleetPreorder'));

// Dashboard components
const FXFleetDashboardPage = loadable(() => import(/* webpackChunkName: "FXFleetDashboardPage" */ '~/app/pages/FXFleetPage/Dashboard/FXFleetDashboardPage'));

const FXFleetRouter = () => (
  <Switch>
    {/* Login and register routes are handled in ScaffoldContainer outside HeaderFooterLayout */}
    <Route exact path={`/:locale(us)${PATHS.FX_FLEET_COMPANY_INFO}`} component={FXFleetCompanyInfoPage} />
    <Route exact path={`/:locale(us)${PATHS.FX_FLEET_PREORDER}`} component={FXFleetPreorderPage} />
    <Route exact path={`/:locale(us)${PATHS.FX_FLEET_DASHBOARD}`} component={FXFleetDashboardPage} />
    {/* FX Fleet order detail route - must come before the general :section route */}
    <Route exact path={`/:locale(us)${PATHS.FX_FLEET_ORDER_DETAILS}`} component={FXFleetDashboardPage} />
    {/* Dynamic fx-fleet dashboard routes */}
    <Route exact path={`/:locale(us)${PATHS.FX_FLEET_DASHBOARD}/:section`} component={FXFleetDashboardPage} />
    {/* Redirect base FX Fleet path to login */}
    <Route exact path={`/:locale(us)${PATHS.FX_FLEET}`}>
      <Redirect to={`/us${PATHS.FX_FLEET_LOGIN}`} />
    </Route>
    <Redirect to={`/us${PATHS.FX_FLEET_LOGIN}`} />
  </Switch>
);

export default FXFleetRouter; 